const dashboardUrl = process.env.REACT_APP_DASHBOARD_URL

export default function useTour() {
  return () => {
    window.location.href = `${dashboardUrl}/tour`
  }
}
